<template>
  <div class="game-container" id="game-container">
    <div class="box">
      <img :src="ImageUrl" />
      <div class="points">
        <div
          class="point"
          v-for="(p, i) in startData.points"
          :key="'point' + i"
          :id="'point-' + i"
          :style="{ left: p.pos.x + 'px', top: +p.pos.y + 'px' }"
          @click="showHideList(i, false)"
        ></div>
        <mp-choose-list
          v-for="(q, j) in modelList"
          @move="showHideList"
          :key="'question_' + j"
          :config="q"
          :answers="answers"
        >
        </mp-choose-list>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import MpList from './MpChooseList/MpChooseListV2';
export default {
  name: 'mp-choose-answer-v2',
  components: { 'mp-choose-list': MpList },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      modelList: {},
      startData: {},
      answers: {},
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    newGame() {
      this.startData = this.startGameConfig;
      this.modelList = {};
      this.answers = Object.assign({}, this.startData.answers);
      var self = this;
      let items = Object.assign({}, this.startData.points);
      var i = -1;
      this.modelList = _.map(items, (item) => {
        i++;
        return {
          posList: item.posList,
          posAns: item.posAns,
          ans: _.isBoolean(item.disableShuffle) ? item.ans : self.shuffle(item.ans),
          cor: item.cor,
          isOpen: false,
          isMoved: false,
          id: 'p' + i,
          point: i,
          val: null,
          isCorrect: false,
          checks: false,
          block: false,
          showWrong: false,
        };
      });
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    showHideList(i, flg, reset) {
      this.modelList.forEach(function (item, j) {
        item.showWrong = false;
        if (item.isCorrect == 1) item.isOpen = true;
        else {
          if (j == i) item.isOpen = flg ? true : !item.isOpen;
          else item.isOpen = false;
        }
        if (reset) item.isOpen = false;
      });
      this.resetCheckStatus();
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var self = this;
      this.modelList.forEach(function (a, i) {
        self.showHideList(i, false, true);
        if (a.val != null) a.checks = true;
        else {
          a.checks = false;
        }
      });
      this.modelList.forEach(function (a, i) {
        a.showWrong = false;
        if (a.cor != a.val) {
          isCorrect = false;
          if (a.val != null && a.checks) a.showWrong = true;
        }
      });
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
  },
  computed: {
    ImageUrl() {
      return this.startGameConfig.bgrSets.imagePath;
    },
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-container {
  display: flex;
  //   padding-top: 155px;
  //   padding-left: 90px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.box {
  background-repeat: no-repeat;
  position: relative;
  margin: auto;
  display: block;
}

.box img {
  position: relative;
  top: 0;
  left: 0;
}

.points {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.point {
  position: absolute;
  border-radius: 50%;
  z-index: 2;
  width: 110px;
  height: 110px;
  cursor: pointer;
}
</style>
